import { useCallback, useEffect, useState } from "react";

export default function useScrollSpy(initial, offset) {
  const [toggleDisplay, setToggleDisplay] = useState(initial);

  const handleChange = useCallback(() => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      windowHeight > offset ? setToggleDisplay(true) : setToggleDisplay(false);
    }
  }, [offset]);

  useEffect(() => {
    window.addEventListener("scroll", handleChange);
    return () => {
      window.removeEventListener("scroll", handleChange);
    };
  }, [handleChange]);

  return toggleDisplay;
}
